import * as Yup from "yup";
import i18next from "i18next";

const phoneRegExp = /^[0-9]{10,15}$/;

export const UpdateProfileSchema = () => Yup.object({

    first_name: Yup.string().required(i18next.t('profile.error_fname')),
    last_name: Yup.string().required(i18next.t('profile.error_lname')),
    gender: Yup.string().required(i18next.t('profile.error_gender')),
    dob: Yup.string().required(i18next.t('profile.error_dob')),
    email: Yup.string().email().required(i18next.t('profile.error_email')),
    mobile_number: Yup.string().matches(phoneRegExp, i18next.t('profile.error_invalid_mobile')).required(i18next.t('profile.error_mobile')),
    profile: Yup.mixed().notRequired(i18next.t('profile.error_profile')),
    district: Yup.string().required(i18next.t('profile.error_district')),
    address: Yup.string().required(i18next.t('profile.error_address')),

});